import { Download, FileSpreadsheet, Loader2 } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function ExportButton({ 
  endpoint, 
  filename, 
  label = "Exporter CSV",
  variant = "secondary" // "primary" or "secondary"
}) {
  const [loading, setLoading] = useState(false);

  const handleExport = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${BACKEND_URL}/api/export/${endpoint}`);
      
      if (!response.ok) {
        throw new Error("Export failed");
      }
      
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename || `export_${Date.now()}.csv`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
      
      toast.success("Export CSV téléchargé!");
    } catch (error) {
      console.error("Export error:", error);
      toast.error("Erreur lors de l'export");
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      onClick={handleExport}
      disabled={loading}
      className={`neo-button-${variant} inline-flex items-center gap-2`}
      data-testid={`export-${endpoint}-btn`}
    >
      {loading ? (
        <Loader2 className="animate-spin" size={18} />
      ) : (
        <FileSpreadsheet size={18} />
      )}
      {label}
    </button>
  );
}
